import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";
import type {
  SellarImportsPayoutCustomFeeCreateRequestType,
  SellarImportsPayoutCustomFeeCreateResponseType,
} from "@sellar-io/api-v2/types";

export function useSellarImportCustomFeeAdd({
  payoutId,
}: {
  payoutId: number;
}) {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SellarImportsPayoutCustomFeeCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `sellar-imports/finance/payouts/${payoutId}/custom-fees`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<SellarImportsPayoutCustomFeeCreateResponseType>(
            response,
          ).data,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SellarImportsPayouts,
          payoutId,
        ],
      });
    },
  });
}
